import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { FieldProps, ScreenProperty } from '../../../../../../../@types/types'
import { CostsScreenValidationResult } from '../../../../../../../@types/validation-types'
import ToggleSwitch from '../../../../../../common/inputs/toggleSwitch/ToggleSwitch'
import HeatingCosts from '../heatingCosts/HeatingCosts'
import { SCREEN_COSTS, SCREENS } from '../../../../../../../services/domain/wizardScreens'

export interface HeatingCostsWithToggleProps extends FieldProps<CostsScreenValidationResult> {
  doReset: (clearingUpOf: ScreenProperty[]) => void
}

const HeatingCostsWithToggle: React.FC<HeatingCostsWithToggleProps> = ({
  insertionData,
  validationMessages,
  screenName,
  onChange,
  doReset,
  wrapperClassName = 'grid-item one-whole margin-top-l',
}) => {
  const { t } = useTranslation()

  const heatingCostsOption = insertionData.heatingCostsOption ?? true
  const [isHeatingIncludedInAdditionalCosts, setIsHeatingIncludedInAdditionalCosts] = useState(heatingCostsOption)

  useEffect(() => {
    setIsHeatingIncludedInAdditionalCosts(heatingCostsOption)
  }, [heatingCostsOption])

  const handleToggleChange = (_field: string, value: boolean) => {
    setIsHeatingIncludedInAdditionalCosts(value)

    // Reset heating costs when toggling ON (heating costs included)
    if (value) {
      doReset([{ screen: SCREENS[SCREEN_COSTS].name, property: 'heatingCosts' }])
      onChange({ screen: screenName, property: 'heatingCostsUnknown' }, false)
    }

    onChange({ screen: screenName, property: 'heatingCostsOption' }, value)
  }

  const handleHeatingCostsUnknownChange = (value: boolean) => {
    if (value) {
      doReset([{ screen: SCREENS[SCREEN_COSTS].name, property: 'heatingCosts' }])
    }

    onChange({ screen: screenName, property: 'heatingCostsUnknown' }, value)
  }

  return (
    <div className={wrapperClassName}>
      <div className='grid'>
        <div className='grid-item'>
          <ToggleSwitch
            id='heating-costs-option-toggle'
            propertyName='heatingCostsOption'
            alignment='maxSpread'
            label={t('wizard.screen.costs.heatingCostsSubtitle')}
            value={isHeatingIncludedInAdditionalCosts}
            onChange={handleToggleChange}
          />
        </div>
        {!isHeatingIncludedInAdditionalCosts && (
          <div className='grid-item one-whole margin-top-m'>
            <HeatingCosts
              screenId='heating-costs-webview'
              heatingCosts={insertionData.heatingCosts}
              heatingCostsValidation={validationMessages!.heatingCosts ?? []}
              onChange={(propertyName, value) => {
                onChange({ screen: screenName, property: propertyName as any }, value)
              }}
              useSimpleLayout={true}
              showLabel={true}
              heatingCostsUnknown={insertionData.heatingCostsUnknown}
              onHeatingCostsUnknownChange={handleHeatingCostsUnknownChange}
            />
          </div>
        )}
      </div>
    </div>
  )
}

export default HeatingCostsWithToggle
